import { useState } from "react"
import classNames from "classnames"

export default function useBbUploadButton({ isChecked, onClickDelete }) {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const componentClass = classNames("bb-button-upload", {
    "bb-button-upload--uploaded": isChecked,
  })

  function showConfirmationModal(e) {
    e.stopPropagation()

    setIsModalVisible(true)
  }

  function hideConfirmationModal() {
    setIsModalVisible(false)
  }

  function handleDelete() {
    if (!!onClickDelete) {
      onClickDelete()
    }

    hideConfirmationModal()
  }

  return {
    componentClass,
    handleDelete,
    isModalVisible,
    showConfirmationModal,
    hideConfirmationModal,
  }
}
